import React from 'react';
import { HeaderStyle } from './header.style';

const Header = () => (
  <header>
    <HeaderStyle>
      <div>
        <h1>Mealplan!</h1>
        <h2>Organizer</h2>
      </div>
    </HeaderStyle>
  </header>
);

export default Header;
